import { ReactNode, Ref, forwardRef } from 'react'

import Image from 'next/image'

import clsx from 'clsx'

type Props = {
	className?: string
	image?: { url: string; dimensions: { width: number; height: number } }
	alt: string
	content?: ReactNode
	contentPosition?: keyof typeof contentPositions
	flip?: boolean
}

const contentPositions = {
	top: 'items-start',
	center: 'items-center',
	bottom: 'items-end'
}

export const TwelveColumnCard = forwardRef(function TwelveColumnCard(
	{ className, image, content, alt = 'Image Description', contentPosition, flip }: Props,
	ref: Ref<HTMLDivElement>
) {
	return (
		<div ref={ref} className={clsx(className, 'relative grid grid-cols-12 items-center')}>
			<div className={clsx('col-span-6 hidden lg:flex', flip && 'order-2')}>
				{image ? (
					<Image
						className="w-full object-cover"
						src={image.url}
						alt={alt}
						width={image.dimensions.width}
						height={image.dimensions.height}
					/>
				) : (
					<div className="w-full h-[300px] bg-bc-blue text-white items-center justify-center flex">
						Select an image
					</div>
				)}
			</div>
			<div
				className={clsx(
					'col-span-12 lg:col-span-6 flex bg-black text-white px-16 py-12 self-stretch',
					flip && 'order-1',
					contentPositions[contentPosition ?? 'top']
				)}
			>
				{content}
			</div>
			<svg
				className={clsx('text-bc-green absolute -bottom-4', flip ? 'left-0 rotate-90' : 'right-0')}
				width="81"
				height="81"
				viewBox="0 0 81 81"
			>
				<path d="M0 81L81 0V81H0Z" fill="currentColor" />
			</svg>
		</div>
	)
})
